import React from 'react';

import { ButtonBase } from '@material-ui/core';

import useTourTooltipStyles from './useTourTooltipStyles';

const TourTooltip = ({
  backProps, primaryProps, skipProps, tooltipProps, index, isLastStep, step,
}) => {
  const classes = useTourTooltipStyles();
  return (
    <div {...tooltipProps} className={classes.tooltip} aria-label="Dashboard tour">
      <h4 className={classes.title}>{step.title}</h4>
      <p className={classes.body}>{step.content}</p>
      <div className={classes.actions}>
        <ButtonBase {...skipProps} className={`${classes.secondaryAction} ${classes.skipAction}`}>Skip tour</ButtonBase>
        {index > 0 && <ButtonBase {...backProps} className={classes.secondaryAction}>Back</ButtonBase>}
        <ButtonBase {...primaryProps} className={classes.primaryAction}>{isLastStep ? 'Done' : 'Next'}</ButtonBase>
      </div>
    </div>
  );
};

export default TourTooltip;
